import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import { addClass, removeClass, closest, createEvent } from '@utils/domUtils';

/* global KTUtil */

const UPDATE_CONTENT_THROTTLE_INTERVAL = 350;
const VALIDATE_CONTENT_DEBOUNCE_INTERVAL = 750;

export default class JobAdEditor {
  static selectorString() {
    return '.JobAdEditor';
  }

  getContactTitle() {
    const data = this.getData();
    return data['contact[title]'];
  }

  isRenderingContactPerson() {
    const data = this.getData();
    const contactIsVisible = data['contact[visible]'];
    const hasContactSectionText =
      data['contact[title]'].length > 0 || data['contact[description]'].length > 0;

    return contactIsVisible && hasContactSectionText;
  }

  getUploadedFiles() {
    return [...this.attachments.querySelectorAll('.dropzone-item')]
      .map(file => {
        const fileNameInput = file.querySelector('.file-upload-value');

        if (fileNameInput && fileNameInput.value.length > 0) {
          return JSON.parse(fileNameInput.value);
        }
        return null;
      })
      .filter(file => file !== null);
  }

  getData() {
    if (!this.data) {
      this.data = this.jobEditSidebar.component.getData();
    }

    return this.data;
  }

  constructor() {
    this.updateData = throttle(this.updateData.bind(this), UPDATE_CONTENT_THROTTLE_INTERVAL);
    // TODO: perhaps just use throttle too
    this.validateContent = debounce(
      this.validateContent.bind(this),
      VALIDATE_CONTENT_DEBOUNCE_INTERVAL,
    );
  }

  render(node, props) {
    this.data = null;

    this.sidebar = node.querySelector('.job-ad-editor-sidebar');
    this.content = node.querySelector('.job-ad-editor-content');

    this.sidebar.addEventListener('click', this.expandEditorSidebar.bind(this));
    this.content.addEventListener('click', this.expandEditorContent.bind(this));

    this.combinedJobAdContentValidatorField = node.querySelector(
      '[name="_combinedJobAdContentValidator"]',
    );

    this.editBlocks = [...this.node.querySelectorAll('.job-ad-editor-sidebar .card-edit-block')];

    this.wrapper = node.querySelector('.job-ad-editor-wrapper');
    this.jobEditSidebar = node.querySelector('.JobEditSidebar');
    this.jobAdContent = node.querySelector('.JobAdContent');

    this.attachments = this.jobEditSidebar.querySelector('[data-prop="attachments"]');

    // listen to changes in form and update content accordingly
    this.jobEditSidebar.addEventListener('contentChanged', this.onContentChange.bind(this));
    const jobTitle = closest(this.jobEditSidebar, 'form').querySelector('[name="jobTitle"]');
    if (jobTitle) {
      jobTitle.addEventListener('change', this.onContentChange.bind(this));
      jobTitle.addEventListener('keyup', this.onContentChange.bind(this));
    }

    // initially update content, in case changes in dom happened before script got loaded!
    setTimeout(() => {
      this.updateData();
    }, 1000);
  }

  onContentChange() {
    this.updateData();
  }

  updateData() {
    this.data = this.jobEditSidebar.component.getData();
    this.jobAdContent.component.setData(this.data);
    this.validateContent();
  }

  validateContent() {
    this.combinedJobAdContentValidatorField.dispatchEvent(createEvent('validate'));
  }

  setSectionData(data) {
    this.jobEditSidebar.component.setSectionData(data);
  }

  setJobAdImage(url) {
    this.jobAdContent.component.setJobAdImage(url);
  }

  expandEditorSidebar() {
    addClass(this.sidebar, 'active');
    removeClass(this.content, 'active');

    removeClass(this.sidebar, 'inactive');
    addClass(this.content, 'inactive');
  }

  expandEditorContent() {
    addClass(this.content, 'active');
    removeClass(this.sidebar, 'active');

    removeClass(this.content, 'inactive');
    addClass(this.sidebar, 'inactive');

    // collapse all blocks in sidebar
    this.editBlocks.forEach(block => {
      const card = KTUtil.data(block).get('card');
      if (card) {
        card.collapse();
      }
    });
  }
}
